// @ts-nocheck
import {
    chain,
    DispatchSetProductFilters,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { addToChainBefore } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainBefore(chain, DispatchSetProductFilters, props => {
    if (props.parameter.excludeMultiLocationCatalogProducts) {
        props.result.excludeMultiLocationCatalogProducts = true;
    }
    if (props.parameter.onlyGreifProducts) {
        props.result.onlyGreifProducts = true;
    }
});
